import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import LOOKUP from 'constants/lookup';
import GenericTable from 'screens/components/advanced/GenericTable';
import Button from 'screens/components/basic/Button';
import MinusAndPlusInput from 'screens/components/basic/MinusAndPlusInput';
import DialogInput from 'screens/components/advanced/DialogInput';
import DecimalInput from 'screens/components/basic/DecimalInput';
import TextInput from 'screens/components/basic/TextInput';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';
import { initializeStorePOSAddProduct, addProductToPOSOder, formInput, clearFormInput } from 'actions/FormActions';
import { checkPriceEstimation } from 'actions/EntityActions';
import { showError } from 'actions/CommonActions';
import { MeasurementType } from 'constants/enums';
import SelectInput from 'screens/components/basic/SelectInput';
import imgDefault from '../../../../images/imgDefault.jpg';
import moment from 'moment';
import { generateRanges } from 'utils/helpers';

const dialogStyle = {
    width: '75%',
    maxWidth: 'none'
};

class POSProductDetails extends Component {
    constructor(props, context) {
        super(props, context);
        this.ws = window.posWebSocket;
        this.state = {
            isManuallyInputted: false
        };
    }

    componentWillMount() {
        this.props.initializeStorePOSAddProduct();
    }

    componentWillReceiveProps(newProps) {
        if (this.props.priceMatrixSelectedIndexRow !== newProps.priceMatrixSelectedIndexRow
            && newProps.priceMatrixSelectedIndexRow !== undefined && newProps.priceMatrixSelectedIndexRow !== null) {
            this.setAmount(newProps.priceMatrixSelectedIndexRow);
        }
    }

    componentDidUpdate(prevProps) {
        const { packageReference, formInput } = this.props;
        if (prevProps.packageReference !== packageReference) {
            formInput(1, "POSProductListPageDetailsQuantity");
        }
    }

    /* Function to calculate the amount of the product by price($)
        triggered by 'Calculate' button next to the Decimal input */
    calculateProductAmount = () => {
        if (this.props.priceEstimationAmount > 0) {
            this.props.checkPriceEstimation(this.props.branchId, this.props.product.id, this.props.priceEstimationAmount)
        }
    }

    setAmount = (index) => {
        const priceMatrixDetail = this.props.product.priceMatrix && this.props.product.priceMatrix.priceMatrixDetails[index];
        this.props.formInput(priceMatrixDetail.weight.toFixed(1).toString(), `${this.props.name}Amount`);
        this.setState({ isManuallyInputted: true });
    }

    addProductToOrder = () => {
        const product = this.props.product;
        if (product.packages.length > 1 && (this.props.packageReference == null || this.props.packageReference == undefined) && !this.props.fulfillmentEnabled) {
            this.props.showError(this.props.t('pos.messages.noPackageReferenceUnitProduct'));
            return;
        }

        let pkDefault = null;
        //Getting the default pk reference
        if (product.packages.length === 1) {
            pkDefault = product.packages[0];
            if (product.packages[0].quantity === 0 && product.packages.find(p => p.quantity > 0)) {
                pkDefault = product.packages.find(p => p.quantity > 0);
            }
        }

        if ((this.props.packageReference != null && this.props.packageReference != undefined) || (pkDefault !== null)) {
            if (product.measurementType === MeasurementType.Unit || product.measurementType === MeasurementType.GramUnit) {
                if (this.props.selectedQuantity) {
                    const selectedQuantity = this.props.selectedQuantity;
                    const finalQuantity = product.measurementType === MeasurementType.Unit ? selectedQuantity : parseFloat((Math.round((this.props.selectedQuantity * product.weightPerUnit) * 10) / 10).toFixed(1));
                    const productModel = {
                        ...product,
                        id: 0,
                        productId: product.id,
                        quantity: finalQuantity,
                        newQuantity: finalQuantity,
                        quantityInStock: pkDefault !== null ? pkDefault.quantity : product.quantity,
                        isManuallyInputted: true,
                        packageReference: (pkDefault !== null) ? pkDefault.packageReference : this.props.packageReference != "0" && this.props.packageReference != null && this.props.packageReference != undefined ? this.props.packageReference : "",
                        isCannabis: product.isCannabis
                    };
                    this.props.addProductToPOSOder(productModel);
                }
                else {
                    this.props.showError(this.props.t('pos.messages.noQuantitySelectedUnitProduct'));
                }
            }
            else {
                const amount = this.props.amount;
                if ((this.props.priceMatrixSelectedIndexRow !== null && this.props.priceMatrixSelectedIndexRow !== undefined) || amount > 0) {
                    const productModel = {
                        ...product,
                        id: 0,
                        productId: product.id,
                        quantity: amount,
                        newQuantity: amount,
                        quantityInStock: pkDefault !== null ? pkDefault.quantity : product.quantity,
                        isManuallyInputted: this.state.isManuallyInputted,
                        packageReference: (pkDefault !== null) ? pkDefault.packageReference : this.props.packageReference != "0" ? this.props.packageReference : "",
                        isCannabis: product.isCannabis
                    };
                    this.props.addProductToPOSOder(productModel);
                } else {
                    this.props.showError(this.props.t('pos.messages.noPriceMatrixSelectedUnitProduct'));
                }
            }
        }
        else {
            this.props.showError(this.props.t('pos.messages.noPackageReferenceUnitProduct'));
        }
        this.props.onCancel();
        this.props.initializeStorePOSAddProduct();
    };

    onCancel = () => {
        this.props.onCancel();
        this.props.initializeStorePOSAddProduct();
    }

    getWeight = () => {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            const model = {
                Command: 'GET WEIGHT',
                Data: null
            };

            this.ws.send(JSON.stringify(model));
        }
    }

    getSpeciesText(speciesValue) {
        let speciesText = 'N.A.';
        if (speciesValue !== null) {
            const foundSpecies = LOOKUP.intSpecies.find(species => species.value === speciesValue);
            if (foundSpecies !== undefined) {
                speciesText = foundSpecies.text;
            }
        }
        return speciesText;
    }

    getMaxQuantity = (product) => {
        if (product) {
            const productPkg = product.packages;
            const { packageReference } = this.props;

            if (productPkg && productPkg.length > 1) {
                if (packageReference === "0") {
                    const foundPackage = productPkg.find(rf => rf.packageReference === "");
                    return foundPackage ? parseInt(foundPackage.quantity) : parseInt(product.quantity);
                }
                const foundPackage = productPkg.find(rf => rf.packageReference === packageReference);
                return foundPackage ? parseInt(foundPackage.quantity) : parseInt(product.quantity);

            } else {
                return parseInt(product.quantity);
            }
        }
    }

    render() {
        const { t } = this.props; 
        const p = this.props;
        const product = p.product;
        const labels = !product ? {} : generateRanges(product);
        let patientIsEmployeeMutiplier = 2;
        if (p.isHighTide) {
            patientIsEmployeeMutiplier = 1.1;
        }
        if (p.isInspired) {
            patientIsEmployeeMutiplier = 1.15;
        }
        if (product === null) {
            return null;
        } else{
            const isUnitProduct = (product.measurementType === MeasurementType.Unit || product.measurementType === MeasurementType.GramUnit);

            let priceMatrixRows = [];

            if (p.memberEnabled) {
                if (product.priceMatrix && product.priceMatrix.priceMatrixDetails) {
                    priceMatrixRows = product.priceMatrix.priceMatrixDetails.filter(i => i.price > 0 || i.memberPrice > 0).map((item) => {
                        return {
                            weightSetting: item.weightSetting,
                            price: `$ ${item.price.toFixed(2)}`,
                            memberPrice: `$ ${item.memberPrice.toFixed(2)}`
                        };
                    })
                }
            } else {
                if (product.priceMatrix && product.priceMatrix.priceMatrixDetails) {
                    priceMatrixRows = product.priceMatrix.priceMatrixDetails.filter(i => i.price > 0 || i.memberPrice > 0).map((item) => {
                        return {
                            weightSetting: item.weightSetting,
                            price: `$ ${item.price.toFixed(2)}`
                        };
                    })
                }
            }

            let isScaleAvailable = false;
            if (this.ws && this.ws.readyState === WebSocket.OPEN && p.posIsScaleAvailable === true) {
                isScaleAvailable = true;
            }

            const selectablePriceTable = true;

            let amountMoreThanStock = false;
            if (isScaleAvailable && p.amount !== 0 && p.amount > product.quantity) {
                amountMoreThanStock = true;
            }

            let labelQuantity = '';

            if (isUnitProduct) {
                let quantityToShow = product.quantity;
                if (quantityToShow > p.doNotShowUnitProductQuantityOver) {
                    labelQuantity = `${p.doNotShowUnitProductQuantityOver} + ${t('pos.productDetails.items')} ${t('pos.productDetails.available')}`;
                } else {
                    labelQuantity = `${parseInt(quantityToShow)} ${t('pos.productDetails.items')} ${t('pos.productDetails.available')}`;
                }

                if (product.onHoldQty > 0) {
                    labelQuantity += `(${product.onHoldQty} ${t('pos.productDetails.onHold')})`;
                }
            } else {
                if (product.quantity > p.doNotShowWeightProductQuantityOver) {
                    labelQuantity = `${p.doNotShowWeightProductQuantityOver} + ${t('pos.productDetails.items')} ${t('pos.productDetails.available')}`;
                } else {
                    labelQuantity = `${(Math.round(product.quantity * 10) / 10).toFixed(1)} ${t('pos.productDetails.items')} ${t('pos.productDetails.available')}`;
                }
            }

            const selectUnitsInWeight = p.selectedQuantity && product.measurementType === MeasurementType.GramUnit
                ? `${(p.selectedQuantity * product.weightPerUnit).toFixed(1)} ${t('pos.productDetails.grams')}`
                : `0.0 ${t('pos.productDetails.gram')}`;

            const priceEstimation = p.priceEstimation;

            let packages = [];
            let selectedPackage = null;

            if (product.packages && product.packages.length > 0) {
                packages = product.packages.map((item) => {
                    let latestPOText = '';
                    if (item.mostRecentPODate) {
                        let mostrecentPODate = moment(item.mostRecentPODate).format('YYYY-MM-DD');
                        latestPOText = ` (${t('pos.productDetails.lastPoDate')}: ${mostrecentPODate})`;
                    }
                    return {
                        text: (item.packageReference === null || item.packageReference === "" ? t('pos.productDetails.noLotNum') : item.packageReference) + " (" + t('pos.productDetails.stock') + " = " + item.quantity + ")" + latestPOText,
                        value: item.packageReference === null || item.packageReference === "" ? "0" : item.packageReference
                    }
                });
                selectedPackage = product.packages.length === 1 ? product.packages[0] : product.packages.find(x => x.packageReference === p.packageReference);
            }

            //Unit of measurement
            let UOM = product.unitOfMeasurement > 0 ? [
                { text: t("constants.none"), value: 0 },
                { text: "%", value: 1 },
                { text: t("constants.mgEach"), value: 2 },
                { text: t("constants.mgCap"), value: 3 },
                { text: t("constants.MgPerMl"), value: 4 },
                { text: t("constants.mgPerUnit"), value: 5 },
                { text: t("constants.mgPerPack"), value: 6 },
                { text: t("constants.mgPerSpray"), value: 7 },
                { text: t("constants.mgPerBottle"), value: 8 },
                { text: t("constants.MgPerG"), value: 9 },
                { text: t("constants.mg"), value: 10 },
              ].filter(i => i.value == product.unitOfMeasurement)[0].text : "";

            const speciesText = this.getSpeciesText(product.species);
            return (
                product ? (
                    <DialogInput
                        title={<DialogHeaderWithClose text={p.title} classicClass="posDialogClassic" handleClose={() => this.onCancel()} />}
                        modal={true}
                        open={p.open}
                        autoScrollBodyContent={true}
                        contentStyle={dialogStyle}
                        actions={[
                            <Button
                                type="CancelButton"
                                name="cancelAddProductButton"
                                className="btn-space"
                                label={t('common.cancel')}
                                onTouchTap={() => this.onCancel()} />,
                            <Button
                                name="addProductButton"
                                label={t('pos.controls.addProductButton')}
                                primary={true}
                                className="btnNewBrandPOS"
                                disabled={amountMoreThanStock}
                                onTouchTap={() => this.addProductToOrder()} />
                        ]}>
                        {
                            (packages.length > 1) &&
                            <SelectInput
                                name={"PackageReference"}
                                fullWidth={true}
                                floatingLabelText={t('pos.productDetails.lotNum')}
                                hintText={t('pos.productDetails.lotNum')}
                                options={packages}
                                defaultValue={packages[0].value}
                            />
                        }
                        {product.measurementType !== MeasurementType.Gram &&
                            <div style={{ display: "flex" }}>
                                <div style={{ display: "flex", flexFlow: "column", margin: "auto 0" }}>
                                    <p style={{ fontSize: 14 }}>{t('pos.productDetails.selectQuant')}</p>
                                    <MinusAndPlusInput name={`${p.name}Quantity`} minimum={parseInt(product.quantity) === 0 ? 0 : 1} maximum={this.getMaxQuantity(product)} />
                                </div>
                                <img className="product-detail-img" src={product.imagesUrls ? product.imagesUrls : imgDefault} />
                            </div>
                        }
                        {
                            <div>
                                <br />
                                <div className="row">
                                    <div className="col-lg-12">
                                        <table className="table table-condensed table-responsive table-user-information sales_add_product_table mb-0 pb-0">
                                            <tbody>
                                                <tr>
                                                    <th>{t('pos.productDetails.sku')}</th>
                                                    <td>{product.sku}</td>
                                                    <th>{t('common.name')}</th>
                                                    <td>{product.name}</td>
                                                    <th>{t('common.category')}</th>
                                                    <td>{product.category}</td>
                                                </tr>
                                                <tr>
                                                    <th>{t('common.type')}</th>
                                                    <td>{product.type}</td>
                                                    <th>{t('pos.productDetails.pricing')}</th>
                                                    <td style={{ maxWidth: "200px" }}>
                                                        {t('pos.productDetails.regPrice')}: ${product.unitPrice} <br />
                                                        {t('pos.productDetails.promPrice')}: ${product.promotionUnitPrice} <br />
                                                        {
                                                            p.posOrder && p.posOrder.patientId > 0 &&
                                                            <span>
                                                                {t('pos.productDetails.memberPrice')}: ${product.memberUnitPrice} <br />
                                                                {
                                                                    product.isElite && <span>
                                                                        {t('pos.productDetails.eliteMemberPrice')}: ${product.eliteMemberUnitPrice} <br />
                                                                    </span>
                                                                }
                                                            </span>
                                                        }
                                                        {selectedPackage
                                                            && p.posOrder && p.posOrder.patientIsEmployee
                                                            && product.isCannabis
                                                            && (p.isHighTide || p.isInspired)
                                                            && <span>{t('pos.productDetails.employeePrice')}: ${(selectedPackage.baseCost * patientIsEmployeeMutiplier).toFixed(2)}</span>
                                                        }
                                                    </td>
                                                    <th>{t('pos.productDetails.stockLevel')}</th>
                                                    <td>{labelQuantity}</td>
                                                </tr>
                                                {!p.isVape &&
                                                    <tr>
                                                        <th>{t('pos.productDetails.thcProduct')}</th>
                                                        <td>{labels.thcLabel}</td>
                                                        <th>{t('pos.productDetails.location')}</th>
                                                        <td>{product.location != null ? product.location : 'N.A.'}</td>
                                                        <th>{t('pos.productDetails.cbdProduct')}</th>
                                                        <td>{labels.cbdLabel}</td>
                                                    </tr>
                                                }
                                                {!p.isVape &&
                                                    <tr>
                                                        <th>{t('pos.productDetails.dfe')}</th>
                                                        <td>{product.dfe ? product.dfe + ' g' : 'N.A.'}</td>
                                                        <th>{t('pos.productDetails.terpene')}</th>
                                                        <td>{product.terpenes && product.terpenes.length > 0 ? product.terpenes.map((x) => (
                                                            <div>
                                                                <span>{x.max > 0
                                                                    ? x.min > 0
                                                                        ? `${x.terpeneName} ${Math.round(x.min * 100.0 * 100) / 100}${UOM} - ${Math.round(x.max * 100.0 * 100) / 100}${UOM}`
                                                                        : `${x.terpeneName} ${Math.round(x.max * 100.0 * 100) / 100}${UOM}`
                                                                    : x.terpeneName}</span>
                                                                <br />
                                                            </div>
                                                        )) : <span>{t('pos.productDetails.naValue')}</span>}</td>
                                                        <th>{t('pos.productDetails.minorCannabinoids')}</th>
                                                        <td style={{ minWidth: product.minorCanabinoids && product.minorCanabinoids.length > 0 ? '120px' : '0' }}>{product.minorCanabinoids && product.minorCanabinoids.length > 0 ? product.minorCanabinoids.map((x) => (
                                                            <div>
                                                                <span>{x.max > 0
                                                                    ? x.min > 0
                                                                        ? `${x.abbreviation} ${Math.round(x.min * 100.0 * 100) / 100}${UOM} - ${Math.round(x.max * 100.0 * 100) / 100}${UOM}`
                                                                        : `${x.abbreviation} ${Math.round(x.max * 100.0 * 100) / 100}${UOM}`
                                                                    : x.abbreviation}</span>
                                                                <br />
                                                            </div>
                                                        )) : <span>{t('pos.productDetails.naValue')}</span>}</td>
                                                    </tr>
                                                }
                                                {p.isVape ? (
                                                    <tr>
                                                        <th>{t('pos.productDetails.brand')}</th>
                                                        <td colSpan={3}>{product.brand !== null ? product.brand : t('pos.productDetails.naUpper')}</td>
                                                        <th>{t('pos.productDetails.variant')}</th>
                                                        <td colSpan={2}>{speciesText}</td>
                                                    </tr>
                                                ) : null}
                                                <tr>
                                                    <th>{t('common.description')}</th>
                                                    <td colSpan={5}>{product.description}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                {
                                    (product.measurementType === MeasurementType.Gram) ? (<div>
                                        <div className="row">
                                            <div className="col-sm-6 col-md-7 col-lg-7">
                                                <DecimalInput
                                                    name={`${this.props.name}PriceEstimation`}
                                                    fullWidth={true}
                                                    floatingLabelText={t('pos.productDetails.calculateAmountByPrice')}
                                                    min={0}
                                                    required
                                                />
                                            </div>
                                            <div className="col-sm-6 col-md-5 col-lg-5 mt-3">
                                                <Button
                                                    name="getAmountofProductByPrice"
                                                    label={t('pos.productDetails.calculate')}
                                                    onTouchTap={() => this.calculateProductAmount()}
                                                    type="FlatButtonPrimary"
                                                    className="pos-calculate-amount-btn btnCalculateProductOrder"
                                                />
                                            </div>
                                        </div>
                                        {
                                            priceEstimation ? (
                                                <div className="row">
                                                    <div className="col-lg-12">
                                                        <table className="table table-condensed table-responsive table-user-information sales_member_nonmember_table">
                                                            <tbody>
                                                                <tr>
                                                                    <th></th>
                                                                    <th>{t('pos.productDetails.qty')}</th>
                                                                    <th>{t('common.price')}</th>
                                                                    <th>{t('pos.productDetails.subtotal')}</th>
                                                                    <th>{t('pos.productDetails.tax')}</th>
                                                                    <th>{t('common.total')}</th>
                                                                    <th>{t('pos.productDetails.leftover')}</th>
                                                                </tr>
                                                            </tbody>
                                                            {this.props.memberEnabled ?
                                                                <tbody>
                                                                    <tr>
                                                                        <th>{t('pos.productDetails.nonMember')}</th>
                                                                        <td>{priceEstimation.nonMember.quantity}g</td>
                                                                        <td>{priceEstimation.nonMember.priceTier}</td>
                                                                        <td>${priceEstimation.nonMember.subTotal.toFixed(2)}</td>
                                                                        <td>${priceEstimation.nonMember.taxes.toFixed(2)}</td>
                                                                        <td>${priceEstimation.nonMember.total.toFixed(2)}</td>
                                                                        <td>${priceEstimation.nonMember.leftOver.toFixed(2)}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <th>{t('common.member')}</th>
                                                                        <td>{priceEstimation.member.quantity}g</td>
                                                                        <td>{priceEstimation.member.priceTier}</td>
                                                                        <td>${priceEstimation.member.subTotal.toFixed(2)}</td>
                                                                        <td>${priceEstimation.member.taxes.toFixed(2)}</td>
                                                                        <td>${priceEstimation.member.total.toFixed(2)}</td>
                                                                        <td>${priceEstimation.member.leftOver.toFixed(2)}</td>
                                                                    </tr>
                                                                </tbody> :
                                                                <tbody>
                                                                    <tr>
                                                                        <th></th>
                                                                        <td>{priceEstimation.member.quantity}g</td>
                                                                        <td>{priceEstimation.member.priceTier}</td>
                                                                        <td>${priceEstimation.member.subTotal.toFixed(2)}</td>
                                                                        <td>${priceEstimation.member.taxes.toFixed(2)}</td>
                                                                        <td>${priceEstimation.member.total.toFixed(2)}</td>
                                                                        <td>${priceEstimation.member.leftOver.toFixed(2)}</td>
                                                                    </tr>
                                                                </tbody>

                                                            }

                                                        </table>
                                                    </div>
                                                </div>
                                            ) : null
                                        }
                                    </div>) : null
                                }
                                {
                                    (product.measurementType === MeasurementType.Gram) && (
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <div className="row">
                                                    <div className="col-lg-6">
                                                        <TextInput name={`${this.props.name}Amount`}
                                                            label={t('pos.addProductDialog.amount.label')}
                                                            floatingLabelText={t('pos.addProductDialog.amount.label')}
                                                            hintText={t('pos.addProductDialog.amount.hintText')}
                                                            fullWidth={true}
                                                            inputStyle={{ fontSize: 20, fontWeight: "bold", color: "black" }}
                                                            floatingLabelStyle={{ fontSize: 20, fontWeight: "bold", color: "rgba(0, 0, 0, 0.6)" }}
                                                            max={!selectablePriceTable ? 0 : product.quantity} />
                                                        {
                                                            amountMoreThanStock ? (
                                                                <p className="text-center text-error">{t('pos.productDetails.requestedAmountOverStock', { amount: this.props.amount.toFixed(1) })}</p>
                                                            ) : null
                                                        }
                                                    </div>

                                                    <div className="col-lg-6 margin-button">
                                                        <Button
                                                            name="GetWeightButton"
                                                            className="pull-right btnNewBrandPOS"
                                                            label={t('pos.productDetails.getScaleWeight')}
                                                            primary={true}
                                                            onTouchTap={() => this.getWeight()} />
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    )
                                }

                                {
                                    (product.measurementType === MeasurementType.GramUnit) ? (
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <br />
                                                <label>{t('pos.productDetails.totalSelectedWeight')}: {selectUnitsInWeight}</label>
                                            </div>
                                        </div>
                                    ) : null
                                }
                                {
                                    (product.measurementType === MeasurementType.Gram || product.measurementType === MeasurementType.GramUnit) ?
                                        (
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <GenericTable
                                                        name={`${this.props.name}PriceMatrix`}
                                                        tableHeaderClassName={(selectablePriceTable) ? "table-products tableHeaderWhiteFont" : ""}
                                                        tableBodyClassName={(selectablePriceTable) ? "orderTable-selectBoxRow table-products" : "orderTable-selectBoxRow"}
                                                        compName={`${this.props.name}PriceMatrix`}
                                                        multiSelectable={false}
                                                        enableSelectAll={false}
                                                        adjustForCheckbox={selectablePriceTable}
                                                        displayRowCheckbox={selectablePriceTable}
                                                        showRowHover={true}
                                                        selectable={selectablePriceTable}
                                                        stripedRows={true}
                                                        columns={this.props.memberEnabled ? [
                                                            { key: "weightSetting", label: t("constants.weightSetting"), visibleMode: "visible-lg visible-xs visible-sm visible-md" },
                                                            { key: "price", label: t("common.price"), visibleMode: "visible-lg visible-xs visible-sm visible-md" },
                                                            { key: "memberPrice", label: t("pos.productDetails.memberPrice"), visibleMode: "visible-lg visible-xs visible-sm visible-md" }
                                                          ] : [
                                                            { key: "weightSetting", label: t("constants.weightSetting"), visibleMode: "visible-lg visible-xs visible-sm visible-md" },
                                                            { key: "price", label: t("common.price"), visibleMode: "visible-lg visible-xs visible-sm visible-md" }
                                                          ]}
                                                        rows={priceMatrixRows} />
                                                </div>
                                            </div>
                                        ) : null
                                }
                                <br />
                            </div>

                        }
                    </DialogInput>
                ) : null
            );
        }
    }
}

function mapStateToProps(state, ownProps) {
    return {
        posOrder: state.entity.posOrder,
        selectedQuantity: state.form[`${ownProps.name}Quantity`] ? parseInt(state.form[`${ownProps.name}Quantity`]) : null,
        priceMatrixSelectedIndexRow: state.form[`${ownProps.name}PriceMatrixSelectedRows`] ? state.form[`${ownProps.name}PriceMatrixSelectedRows`][0] : null,
        amount: state.form[`${ownProps.name}Amount`] ? parseFloat(state.form[`${ownProps.name}Amount`]) : 0,
        doNotShowUnitProductQuantityOver: state.common.applicationSettings.doNotShowUnitProductQuantityOver,
        doNotShowWeightProductQuantityOver: state.common.applicationSettings.doNotShowWeightProductQuantityOver,
        posIsScaleAvailable: state.form['posIsScaleAvailable'] === false ? false : true,
        branchId: state.common.branchId,
        priceEstimation: state.entity.productPriceEstimation,
        priceEstimationAmount: state.form[ownProps.name + 'PriceEstimation'] ? parseFloat(state.form[ownProps.name + 'PriceEstimation']) : 0,
        packageReference: state.form.PackageReference,
        isMedical: state.common.applicationSettings.isMedical,
        isVape: state.common.applicationSettings.isVape,
        memberEnabled: state.common.applicationSettings.memberEnabled,
        fulfillmentEnabled: state.common.applicationSettings.fulfillmentEnabled,
        isHighTide: state.common.applicationSettings.isHighTide,
        isInspired: state.common.applicationSettings.isInspired
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        initializeStorePOSAddProduct: () => dispatch(initializeStorePOSAddProduct(ownProps.name)),
        showError: (message) => dispatch(showError(message)),
        addProductToPOSOder: (product) => dispatch(addProductToPOSOder(product)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        checkPriceEstimation: (branchId, productId, amount) => dispatch(checkPriceEstimation(branchId, productId, amount)),
        clearFormInput: (name) => dispatch(clearFormInput(name))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSProductDetails))